import { Input, DatePicker, Select, Button, ConfigProvider } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import viVN from "antd/es/locale/vi_VN";
import dayjs from "dayjs";
import "dayjs/locale/vi"; // Bắt buộc: import ngôn ngữ
dayjs.locale("vi"); // Thiết lập ngôn ngữ cho dayjs
import { IoSearch } from "react-icons/io5";
import { FormattedMessage, useIntl } from "react-intl";

const { RangePicker } = DatePicker;

const CustomToolbar = ({
  searchValue,
  onSearchChange,
  dateRange,
  onDateRangeChange,
  sourceOptions = [],
  statusOptions = [],
  sourceValue,
  onSourceChange,
  statusValue,
  onStatusChange,
  onSearch,
}) => {
  const intl = useIntl();
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="my-3 md:my-6 bg-gray-50 p-4">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-2 lg:gap-4 rounded-lg">
        <div className="col-span-1">
          <label className="block text-xs font-medium mb-1 text-gray-500 float-left">
            {<FormattedMessage id="HISTORY.SEARCH" />}
          </label>
          <Input
            placeholder={intl.formatMessage({ id: "HISTORY.SEARCH" })}
            prefix={<SearchOutlined className="text-[#52c41a]" />}
            value={searchValue}
            onChange={onSearchChange}
            onKeyDown={handleKeyDown}
            allowClear
            className="h-10 rounded-md hover:border-[#52c41a] focus-within:border-[#52c41a] focus-within:shadow-[0_0_0_2px_rgba(82,196,26,0.2)]"
          />
        </div>
        <div className="col-span-1">
          <label className="block text-xs font-medium mb-1 text-gray-500 float-left">
            {<FormattedMessage id="HISTORY.TIME" />}
          </label>
          <ConfigProvider locale={viVN}>
            <RangePicker
              className="w-full h-10 rounded-md self-end"
              value={dateRange}
              onChange={onDateRangeChange}
              format="DD/MM/YYYY HH:mm"
              showTime={{ format: "HH:mm" }}
              placeholder={[
                intl.formatMessage({ id: "HISTORY.START_DATE" }),
                intl.formatMessage({ id: "HISTORY.END_DATE" })
              ]}
            />
          </ConfigProvider>
        </div>
        <div className="col-span-1">
          <label className="block text-xs font-medium mb-1 text-gray-500 float-left">
            {<FormattedMessage id="HISTORY.SOURCE" />}
          </label>
          <Select
            className="w-full h-10 rounded-md text-left"
            value={sourceValue}
            onChange={onSourceChange}
            options={sourceOptions}
            placeholder={intl.formatMessage({ id: "HISTORY.SELECT_SOURCE" })}
            allowClear
          />
        </div>
        <div className="col-span-1">
          <label className="block text-xs font-medium mb-1 text-gray-500 float-left">
            {<FormattedMessage id="HISTORY.STATUS" />}
          </label>
          <Select
            className="w-full h-10 rounded-md text-left"
            value={statusValue}
            onChange={onStatusChange}
            options={statusOptions}
            placeholder={intl.formatMessage({ id: "HISTORY.SELECT_STATUS" })}
            allowClear
          />
        </div>
        <div className="col-span-2 md:col-span-1">
          <label className="block text-xs font-medium mb-1 text-gray-500 float-left">
            &nbsp;
          </label>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#50b553",
                defaultBg: "#50b553",
                defaultHoverBg: "#27872a",
              },
            }}
          >
            <Button
              type="primary"
              className="h-10 w-full text-base text-white rounded-md flex items-center justify-center px-6"
              onClick={onSearch}
              icon={<IoSearch className="size-4" />}
            >
              {<FormattedMessage id="HISTORY.SEARCH" />}
            </Button>
          </ConfigProvider>
        </div>
      </div>
    </div>
  );
};

CustomToolbar.propTypes = {
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  dateRange: PropTypes.any,
  onDateRangeChange: PropTypes.func,
  sourceOptions: PropTypes.array,
  statusOptions: PropTypes.array,
  sourceValue: PropTypes.any,
  onSourceChange: PropTypes.func,
  statusValue: PropTypes.any,
  onStatusChange: PropTypes.func,
  onSearch: PropTypes.func,
};

export { CustomToolbar };
